import { Zap } from "lucide-react";

const ITEMS = [
  "Immersion totale",
  "5 tapis omni KAT VR",
  "Chaise rotative 360°",
  "Esport co-op",
  "Réalité virtuelle premium",
  "Sessions dès 5€",
];

export const MarqueeTicker = () => (
  <div
    data-testid="marquee-ticker"
    className="relative overflow-hidden border-y border-cyan-500/10 bg-surface py-6"
  >
    <div className="flex w-max animate-marquee items-center gap-12 pr-12">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-12">
          <span
            className={`whitespace-nowrap font-display text-2xl font-bold uppercase tracking-wide sm:text-3xl ${
              i % 2 === 0 ? "text-slate-200" : "text-stroke-cyan"
            }`}
          >
            {item}
          </span>
          <Zap className="h-5 w-5 shrink-0 text-fuchsia-500" fill="currentColor" />
        </span>
      ))}
    </div>
  </div>
);
